import { useState } from "react";
import T from "../theme";
import { Card } from "../components/ui/Card";
import { Icon } from "../components/ui/Icon";
import { useIsMobile } from "../hooks/useIsMobile";

export const CondoSelect = ({ user, condos, onSelectCondo, onLogout, dark, onToggleDark }) => {
  const isMobile = useIsMobile();
  const [hovId, setHovId] = useState(null);
  const firstName = user?.name?.split(" ")[0] || "";

  return (
    <div style={{
      minHeight: "100vh", background: T.bg,
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", padding: isMobile ? "24px 16px" : "48px",
      fontFamily: "'Inter',system-ui,sans-serif",
    }}>
      {/* Header / Greeting */}
      <div style={{ textAlign: "center", marginBottom: isMobile ? 28 : 44, animation: "fadeIn 0.4s ease" }}>
        <div style={{
          width: 56, height: 56, borderRadius: 16,
          background: T.primaryLight, display: "flex",
          alignItems: "center", justifyContent: "center",
          margin: "0 auto 20px",
        }}>
          <Icon name="building" size={28} color={T.primary} />
        </div>
        <h1 style={{ fontSize: isMobile ? 24 : 30, fontWeight: 800, color: T.text, marginBottom: 8, letterSpacing: "-0.3px" }}>
          Olá, {firstName}
        </h1>
        <p style={{ color: T.textMuted, fontSize: 15, lineHeight: 1.5 }}>
          Selecione o condomínio que pretende gerir.
        </p>
      </div>

      {/* Condo Cards Grid */}
      <div style={{
        width: "100%", maxWidth: 640,
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fill, minmax(280px, 1fr))",
        gap: 14,
        animation: "fadeIn 0.5s ease 0.1s both",
      }}>
        {condos.map(condo => (
          <Card
            key={condo.id}
            hoverable
            onClick={() => onSelectCondo(condo)}
            style={{
              padding: "22px 20px", cursor: "pointer",
              transition: "all 0.18s ease",
              border: `1px solid ${hovId === condo.id ? T.primary : T.border}`,
              boxShadow: hovId === condo.id ? `0 0 0 1px ${T.primary}, ${T.shadow}` : T.shadow,
            }}
            onMouseEnter={() => setHovId(condo.id)}
            onMouseLeave={() => setHovId(null)}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                background: T.primaryLight,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <Icon name="building" size={20} color={T.primary} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: 15, fontWeight: 600, color: T.text, marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {condo.name}
                </p>
                {condo.morada && (
                  <p style={{ fontSize: 13, color: T.textMuted, marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {condo.morada}
                  </p>
                )}
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {condo.numFracoes > 0 && (
                    <span style={{ fontSize: 12, color: T.textLight }}>{condo.numFracoes} frações</span>
                  )}
                  <span style={{
                    fontSize: 11, fontWeight: 600, borderRadius: 4, padding: "1px 7px",
                    background: condo.role === "admin" ? T.primaryLight : T.bg,
                    color: condo.role === "admin" ? T.primary : T.textMuted,
                  }}>
                    {condo.role === "admin" ? "Administrador/a" : "Condómino/a"}
                  </span>
                </div>
              </div>
              <Icon name="chevron" size={16} color={T.textLight} />
            </div>
          </Card>
        ))}
      </div>

      {/* Footer actions */}
      <div style={{ marginTop: 36, display: "flex", alignItems: "center", gap: 20 }}>
        <button
          onClick={onToggleDark}
          style={{ background: "none", border: "none", cursor: "pointer", color: T.textMuted, display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontFamily: "inherit" }}>
          <Icon name={dark ? "sun" : "moon"} size={14} color={T.textMuted} />
          {dark ? "Claro" : "Escuro"}
        </button>
        <button
          onClick={onLogout}
          style={{ background: "none", border: "none", cursor: "pointer", color: T.textMuted, display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontFamily: "inherit" }}>
          <Icon name="logout" size={14} color={T.textMuted} />
          Sair
        </button>
      </div>
    </div>
  );
};
